import React, { useState, useEffect } from 'react';
import { CarehomeAddressType } from '@typings/CarehomeInfo';
// eslint-disable-next-line import/no-cycle
import AlternativeAddress from './components/AternativeAddress';
// eslint-disable-next-line import/no-cycle
import CurrentAddress from './components/CurrentAddress';
// eslint-disable-next-line import/no-cycle
import NextOfKin from '../NextOfKin';
import { NextOfKinDetailsType } from '../NextOfKinDetails';

export interface AddressDataType {
  isResideInCurrentAddress: boolean;
  currentAddressType: string;
  alternativeAddressType: string;
  currentAddress: CarehomeAddressType;
  alternativeAddress: CarehomeAddressType;
}

interface AddressProps {
  fullName: string;
  setAddress: React.Dispatch<React.SetStateAction<AddressDataType>>;
  addressFromData: AddressDataType;
  nextOfKinDetails: NextOfKinDetailsType;
  setNextOfKinDetails: React.Dispatch<
    React.SetStateAction<NextOfKinDetailsType>
  >;
}
const Address: React.FC<AddressProps> = ({
  fullName,
  setAddress,
  addressFromData,
  nextOfKinDetails,
  setNextOfKinDetails,
}) => {
  const [currentAddressType, setCurrentAddressType] = useState('');
  const [alternativeAddressType, setAlternativeAddressType] = useState('');
  const [isReside, setIsReside] = useState(false);
  const [currentAddress, setCurrentAddress] = useState<CarehomeAddressType>({
    addressLine1: '',
    addressLine2: '',
    city: '',
    county: '',
    postCode: '',
  });
  const [alternativeAddress, setAlternativeAddress] =
    useState<CarehomeAddressType>({
      addressLine1: '',
      addressLine2: '',
      city: '',
      county: '',
      postCode: '',
    });

  useEffect(() => {
    setAddress(prev => ({ ...prev, currentAddress, alternativeAddress }));
  }, [currentAddress, alternativeAddress, setAddress]);

  useEffect(() => {
    setAddress(prev => ({
      ...prev,
      currentAddressType,
      alternativeAddressType,
      isResideInCurrentAddress: isReside,
    }));
  }, [currentAddressType, alternativeAddressType, setAddress, isReside]);

  return (
    <div>
      <CurrentAddress
        fullName={fullName}
        setCurrentAddress={setCurrentAddress}
        currentAddressType={currentAddressType}
        setCurrentAddressType={setCurrentAddressType}
        isReside={isReside}
        setIsReside={setIsReside}
        addressFromData={addressFromData}
      />
      <NextOfKin
        nextOfKinDetails={nextOfKinDetails}
        setNextOfKinDetails={setNextOfKinDetails}
      />
      <AlternativeAddress
        fullName={fullName}
        alternativeAddressType={alternativeAddressType}
        setAlternativeAddressType={setAlternativeAddressType}
        alternativeAddress={alternativeAddress}
        setAlternativeAddress={setAlternativeAddress}
        addressFromData={addressFromData}
      />
    </div>
  );
};

export default Address;
